/* eslint-disable func-names */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-useless-return */
import fetch from "node-fetch";
import { useEffect, useState, useContext } from "react";
import { cloudinaryImageAdapter } from "../sharedComponents/CloudinaryImageAdapter";
import { getThingsToDoURL } from "./gatsby-helpers";
import { RCL as useTranslation } from "../components/RCL";
import { PageContext } from "../components/PageContext";
import nexusImageUrlTransformation from "./nexusUrlTransformation";

const useNexusFetchHook = (code, isDetailsModal, excursionData, isExcursion) => {
	const [val, setVal] = useState([]);
	const pageContext = useContext(PageContext);
	const lang = pageContext.locale.slice(0, 2);
	const exploreMoreLabel = useTranslation({
		searchKey: "explore-more",
	});
	const modalMessage = useTranslation({
		searchKey: "nexus-external-popup-message",
	});

	let URL = `${process.env.GATSBY_HOTEL_INFOSERVICE_API}/sunwing/${lang}/excursionsDestinationCode?dest=${code}`;

	if (isExcursion) {
		URL = `${process.env.GATSBY_HOTEL_INFOSERVICE_API}/sunwing/${lang}/excursion/${code}`;
	}

	useEffect(() => {
		if (!excursionData?.length) {
			fetch(URL)
				.then(res => res.json())
				.then(response => {
					let colections = [];
					if (isExcursion) {
						colections = [
							...response[0].HotelImages.Img16X9.map((img, idx) => ({
								id: `excursion-image-${idx}`,
								imageTitle: `excursion-image-${idx}`,
								src: nexusImageUrlTransformation(img, 1200, true),
							})),
						];
					} else {
						colections = response[0]?.ExcursionsCollection?.Items.map(res => {
							const excursionPageUrl = res?.NexusExcursionPageUrlCollection?.Items.map(item => ({
								excursionUrl: item?.ExcursionUrl,
								excursionPageName: item?.ExcursionPageName,
								destinationCode: res?.DestinationCode,
							}));
							return {
								destinationCode: res?.DestinationCode,
								destinationName: res?.DestinationName,
								excursionImages: res?.ExcursionImages[0],
								highlights: res?.Highlights,
								juniperProductCode: res?.JuniperProductCode,
								nexusExcursionPageUrl: excursionPageUrl,
								productName: res?.ProductName,
								videoUrl: res?.VideoUrl,
							};
						});
					}
					setVal(colections);
				});
		}
	}, [code, lang]);

	if (isExcursion) {
		return { galleryImages: val };
	}

	return val?.reduce(
		(accumulator, excursion) => {
			const option = excursion?.options?.find(o => o?.ttsFullCode);
			const cardData = {
				modalMessage,
				id: option?.id || "",
				title: option?.optionName || excursion?.productName,
				subTitle: excursion?.sunwingContent?.sunwingMainCategory?.category || "",
				link: {
					text: exploreMoreLabel,
					to: isDetailsModal
						? excursion?.nexusExcursionPageUrl?.find(e => e?.destinationCode?.includes(code))
								?.excursionUrl
						: getThingsToDoURL(lang, excursion?.slug ?? pageContext?.slug, excursion?.productName),
				},
				image: null,
			};

			const excursionCode = option?.ttsFullCode.substring(0, 6) || excursion?.destinationCode; // First 6 chars are tts codes
			// complete the data for excursion cards
			cardData.image = cloudinaryImageAdapter({
				cloudinaryImage: {
					width: 1024,
					height: 576,
					public_id: `/sunwing-prod/ExcursionImages/${excursionCode}/16x9/001`,
					nexusImage: excursion?.excursionImages,
				},
				aspectRatio: 1,
				maxWidth: 200,
				title: option?.optionName || excursion?.productName,
			});
			let panelData = null;
			if (isDetailsModal) {
				// complete the data for excursion card panels
				panelData = {
					id: option?.id || "",
					title: option?.optionName || excursion?.productName,
					image: null,
					destination: excursion?.destinationName,
					duration: option?.activityDuration || "",
					frequency: excursion?.frequency,
					departure: option?.transportationMeetingPoint || "",
					dropOff: option?.transportationMeetingPoint || "",
					description: excursion?.completeDescription?.childMarkdownRemark?.html || "",
					locationCode: option?.ttsFullCode?.substring(0, 6) || excursion?.destinationCode,
				};

				panelData.image = cloudinaryImageAdapter({
					cloudinaryImage: {
						width: 1024,
						height: 576,
						public_id: `/sunwing-prod/ExcursionImages/${
							option?.ttsFullCode.substring(0, option?.ttsFullCode.indexOf("_") - 3) ||
							excursion?.destinationCode
						}/16x9/001`,
					},
					title: option?.optionName || excursion?.productName,
				});
			}
			return {
				excursionCardData: [...accumulator.excursionCardData, cardData],
				excursionPanelData: [...accumulator.excursionPanelData, panelData],
			};
		},
		{
			excursionCardData: [],
			excursionPanelData: [],
		}
	);
};

export default useNexusFetchHook;
